module.exports = __webpack_public_path__ + "static/media/linkedin.5b238434.svg";